import { render, staticRenderFns } from "./Kontoeinstellungen.vue?vue&type=template&id=fc6b9f56"
import script from "./Kontoeinstellungen.vue?vue&type=script&lang=js"
export * from "./Kontoeinstellungen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports